





























import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { Route } from 'vue-router'
import NextButton from '@/shared/NextButton.component.vue'

import {
  STORE_SELECTED_CUSTOMER,
  CONNECT_WS,
  CLOSE_WS,
  CLEAR_JOB_LIST,
  CLEAR_PROJECTS,
  FETCH_CUSTOMERS
} from '@/system/store/action-types'
import { GET_CUSTOMERS_LIST, GET_IS_CONNECTED, GET_SELECTED_CUSTOMER } from '@/system/store/getter-types'
import { JOB_LIST_NAME } from '@/features/job/job.router'
import { ICustomer, ICustomerOption } from '@/features/auth/store'
import { IActionType } from '@/system/store'

import { authLocalisationKeys } from '@/features/auth/auth.localisation'

@Component({
  components: {
    NextButton
  }
})
export default class ChooseCustomer extends Vue {
  private selectedValue: ICustomerOption | null = null
  private nextRoute: string = JOB_LIST_NAME
  private translations = authLocalisationKeys
  private options: ICustomer[] = []

  @Getter(GET_IS_CONNECTED) isConnected!: boolean
  @Getter(GET_CUSTOMERS_LIST) customers!: ICustomer[]
  @Getter(GET_SELECTED_CUSTOMER) currentCustomer!: ICustomer
  @Action(CONNECT_WS) connectWs!: IActionType
  @Action(FETCH_CUSTOMERS) fetchCustomersAction!: IActionType
  @Action(STORE_SELECTED_CUSTOMER) storeSelectedCustomer!: IActionType<ICustomer>
  @Action(CLEAR_JOB_LIST) clearJobList!: IActionType
  @Action(CLEAR_PROJECTS) clearProjects!: IActionType

  get customerForSelect (): (ICustomerOption)[] {
    return this.customers.map((customer: ICustomer) => ({
      ...customer,
      label: customer.name,
      value: customer.id
    }))
  }

  get disableNextBtn (): boolean {
    return !(this.selectedValue && this.selectedValue.id)
  }

  @Watch('isConnected')
  getCustomersList () {
    console.log('Fetching customers list')
    if (!this.isConnected) {
      return
    }
    this.fetchCustomersAction()
  }

  private async created (): Promise<void> {
    const { id: value, name: label }: ICustomer = this.currentCustomer
    if (value) {
      this.selectedValue = {
        ...this.currentCustomer,
        label,
        value
      }
      await this.$store.dispatch(CLOSE_WS)
    }

    // await this.$store.dispatch(CLOSE_WS)
    this.clearJobList()
    this.clearProjects()
    if (this.isConnected) {
      this.fetchCustomersAction()
    }
  }

  public handleSelect (customer: ICustomer): void {
    if (customer) {
      const { id, name, vertical } = customer
      this.storeSelectedCustomer({ id, name, vertical })
      this.$store.dispatch(CLOSE_WS)
    }
  }

  private handleClear (): void {
    this.selectedValue = null
  }

  private filterFn (filter: string, update: Function, abort: Function) {
    update(() => {
      const needle: string = filter.toLowerCase()
      this.options = this.customerForSelect.filter(({ label }: ICustomerOption) => label.toLowerCase().includes(needle))
    })
  }
}
